import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import SiteInfoDetail from './SiteInfoDetail';
import * as siteInfoActions from './../../../../../actions/siteInfoAction';

const mapStateToProps = state => {
    return {
        siteInfoState: state.siteInfoReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSiteInfoDetail: (id) => dispatch(siteInfoActions.getSiteInfoDetail(id)),
        setSiteInfoDetail: (siteinfo) => dispatch(siteInfoActions.setSiteInfoDetail(siteinfo)),
        updateSiteInfoDetail: (siteinfo) => dispatch(siteInfoActions.updateSiteInfoDetail(siteinfo)),
        createSiteInfoDetail: (siteinfo) => dispatch(siteInfoActions.createSiteInfoDetail(siteinfo)),
        createSiteInfoTranslate: (siteinfo, language) => dispatch(siteInfoActions.createSiteInfoTranslate(siteinfo, language)),
        updateSiteInfoTranslate: (siteinfo, language) => dispatch(siteInfoActions.updateSiteInfoTranslate(siteinfo, language)),
        deleteSiteInfoTranslate: (siteinfo, refreshParams) => dispatch(siteInfoActions.deleteSiteInfoTranslate(siteinfo, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SiteInfoDetail));
